import React, { useEffect, useState } from 'react';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function SortingSelection() {
  const [value, setValue] = useState('Sort By: ');
  const { setShortingBy, search } = useSearchHooks();
  const sortArr = [
    {
      id: 0,
      txt: 'Price - Low to High',
      sort: 0,
    },
    {
      id: 1,
      txt: 'Price - High to Low',
      sort: 1,
    },
    {
      id: 2,
      txt: 'Percent Savings',
      sort: 2,
    },
    {
      id: 3,
      txt: 'Star Rating',
      sort: 3,
    },
    {
      id: 5,
      txt: 'Benefit Amount',
      sort: 5,
    },
    {
      id: 6,
      txt: 'Select Custom 1',
      sort: 6,
    },
    {
      id: 4,
      txt: 'Select Custom 2',
      sort: 4,
    },
  ];

  const handleSelect = (e) => {
    setValue(e);
    setShortingBy(e);
  };

  useEffect(() => {
    setValue(search.sortingBy);
  }, []);

  return (
    <div className="sortData">
      <DropdownButton title={value} variant="warning" className="dropdown-menu-align-right" onSelect={handleSelect}>
        {sortArr.map((item) => {
          return (
            <Dropdown.Item eventKey={item.txt} key={item.id}>
              {item.txt}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
    </div>
  );
}
